<template lang="html">
  <div id="product-description-page">

    <section class="container oversized-container">
      <div class="row">
        <div class="col-md-12 mt-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">{{ $t("shared.titles.home") }}</router-link></li>
              <li class="breadcrumb-item"><router-link to="/productos">{{ $t("shared.titles.products") }}</router-link></li>
              <li class="breadcrumb-item"><router-link :to="'/productos/categoria/'+producto.categories_id['id']">{{ $t("shared.titles.list") }}</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{producto.title}}</li>
            </ol>
          </nav>
        </div>
      </div>
    </section>

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-lg-7 col-gallery">
          <h2 class="d-lg-none product-title">{{ producto.title }}</h2>

          <!-- Big images -->
          <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide v-for="(i, iInx) in producto.galery" :key="'iInx-'+iInx">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+i+')' }"></div>
            </swiper-slide>

            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          </swiper>
          <!--  -->

          <!-- Thumbs -->
          <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
            <swiper-slide class="slide-1" v-for="(i, itInx) in producto.galery" :key="'itInx-'+itInx">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+i+')' }"></div>
            </swiper-slide>
          </swiper>
          <!--  -->

          <div class="box-description" v-html="producto.description"></div>
        </div>

        <div class="col-lg-5 col-description">
          <h2 class="d-none d-lg-block product-title">{{ producto.title }}</h2>

          <h5 class="subtitle">{{ $t("productDetail.titles.characteristics") }}</h5>
          <div class="box-features" v-html="producto.features"></div>

          <h5 class="subtitle">{{ $t("productDetail.titles.finishes") }}</h5>
          <div class="box-finishes">
            <div class="col-4 col-md-3 col-lg-4 box-finish" v-for="(finish, imageIndex) in producto.finishes_id" :key="imageIndex" @click="setIndex(imageIndex)">
              <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+finish.finish_image+')' }">
                <img src="public/images/shared/article.png">
              </div>
              <h6 class="name">{{ finish.name }}</h6>
            </div>
          </div>

          <h5 class="subtitle">{{ $t("productDetail.titles.video_gallery") }}</h5>
          <div class="box-videos">
            <swiper class="swiper" :options="videosOptions">
              <swiper-slide v-for="(vidP, pInx) in producto.galeryVideo" :key="pInx">
                <a class="t-150 video" @click="openVideoModal('https://www.youtube.com/embed/'+vidP.url)">
                  <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+vidP.imagen+')' }"></div>
                </a>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <div class="col-12 col-projects">
          <swiper class="swiper" :options="projectsOptions">
            <swiper-slide v-for="(project, pInx) in producto.projects_id" :key="pInx">
              <div class="col-12 px-0 col-project-sample">
                <router-link class="pj-link" :to="'/proyectos/categoria/'+project.id">
                  <div class="placed-backg box-img" v-bind:style="{'background-image': 'url('+project.project_image+')'}">
                    <img src="public/images/pages/home/p-empty.png">
                  </div>
                  <div class="box-info">
                    <h5>{{ project.name }}</h5>
                  </div>
                </router-link>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

        <div class="col-lg-12 col-large-video">
          <div class="video">
            <iframe v-if="producto.video" width="100%" height="500" :src="'https://www.youtube.com/embed/'+producto.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>   
          </div>
        </div>
      </div>
    </section>

    <b-modal ref="modal-video" modal-class="modal-video" hide-footer centered size="lg" title="">
      <iframe :src="modal.videoUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </b-modal>

    <CoolLightBox
      :items="producto.finish_id"
      :index="index"
      :effect="'fade'"
      loop
      @close="index = null">
    </CoolLightBox>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
  components: {
    CoolLightBox,
  },

  data(){
    return{
      // == Carousels options ==
      swiperOptionTop: {
        loop: true,
        loopedSlides: 9, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 9, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      videosOptions: {
        loop: true,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      },
      projectsOptions: {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: true,
        autoplay: true,

        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },

        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },
      // == ==

      modal: {
        videoUrl: ''
      },
      index: null,

      producto: {
        id: 4,
        title: "Ventanas y puertas oscilobatientes",
        image_id: 1007,
        description: "<p>Las ventanas oscilobatientes tienen una apertura horizontal de 180º, y una apertura vertical de aproximadamente 45º, ambas son perfectas para ventilar la casa por la mañana en su opción de apertura horizontal, y para hacer circular una mayor corriente de aire, gracias a la apertura vertical. </p><p><br></p><p>Este tipo de ventanas son más versátiles y puede adaptarse mejor a los espacios de la casa. Además, pueden alcanzar un mayor aislamiento acústico y térmico, factor fundamental para la energía medidas de ahorro con fines a domicilio. De hecho, las cifras no son engañosas: una bueno aislamiento térmico nos ayuda a reducir el CO2 emitido por el consumo de calefacción y aire acondicionado en nuestras viviendas, hasta en un 30%. </p><p><br></p><p>El sistema de cierre hermético entre el marco y la hoja permite un mayor ahorro. Este cierre perimetral, combinado con un DUO o vidrio laminado es una solución perfecta contra el ruido y el calor externo </p><p><br></p><p>Para más información sobre los perfiles para este tipo de ventanas <a href=\"https://www.vidiwis.com/public/downloads/IDEAL%202000_MEX.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">aquí</a>.</p><p><br></p><p>Se puede combinar con <a href=\"https://www.vidiwis.com/#/detalle/product/18\" rel=\"noopener noreferrer\" target=\"_blank\">Mosquitero enrollable</a> o <a href=\"https://www.vidiwis.com/#/detalle/product/17\" rel=\"noopener noreferrer\" target=\"_blank\">Mosquitero Fijo.</a></p>",
        features: "<ul><li>IDEAL 2000 ALUPLAST (marco 65mm y hoja 77mm).</li><li>Apertura interior.</li><li>Herrajes Sigenia de cierre perimetral.</li><li>Factor U=1.6 W/(m2 <span class=\"ql-font-monospace\">×</span> K), <a href=\"https://www.vidiwis.com/public/downloads/IDEAL_2000-U%20Value%20Certificate.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Certificado Aquí</a>.</li><li>Aislamiento acustico hasta 47 dB</li><li><a href=\"https://www.vidiwis.com/public/downloads/Oscilobatiente-esloventanas-tilt-turn.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Dibujo de ventana Oscilobatiente</a></li></ul><p><br></p>",
        categories_id: {
          "id": 1,
          "label": "Ventanas y Puertas de PVC"
        },
        created_at: "2020-03-03 21:26:14",
        updated_at: "2021-07-14 12:24:52",
        title_en: "Tilt & Turn Windows",
        description_en: "<p>The tilt &amp; turn windows have a horizontal opening of 180º, and a vertical opening of approximately 45º, both are perfect to ventilate the house in the morning in its horizontal opening option and to circulate a greater airstream, thanks to the vertical opening.</p><p>&nbsp;</p><p>This type of window is more versatile and can adapt better to the spaces of the house. In addition, they can reach greater acoustic and thermal insulation, which is a fundamental factor for energy-saving measures purposes at home. In fact, the figures are not misleading: good thermal insulation helps us to reduce the CO2 emitted by the consumption of heating and air conditioning in our homes, by up to 30%. </p><p>&nbsp;</p><p>The hermetic closure system between the frame and the leaf allows greater savings. This perimeter closure, combined with a DUO or laminated glass is a perfect solution against noise and external heat </p><p><br></p><p>For more information about the profiles for this type of window <a href=\"https://www.eslowindows.com/public/downloads/ideal_2000_gb.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">here</a>.</p><p><br></p><p>It can be combined with a <a href=\"https://en.eslowindows.com/#/detalle/product/18\" rel=\"noopener noreferrer\" target=\"_blank\"><u>Retractable Screen</u></a> o&nbsp;<a href=\"https://en.eslowindows.com/#/detalle/product/17\" rel=\"noopener noreferrer\" target=\"_blank\"><u>Fixed Mosquito Net</u></a>.</p>",
        features_en: "<ul><li>IDEAL 2000 ALUPLAST (frame 2-1/2\" and sash 3\")</li><li>InSwing</li><li>Sigenia Hardware Perimeter closing points</li><li>Factor U = 0.28 Btu/H/F2/°F, <a href=\"https://www.eslowindows.com/public/downloads/IDEAL_2000-U%20Value%20Certificate.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Certificate here</a></li><li>Acoustic isolation up to 47 dB</li><li><a href=\"https://www.eslowindows.com/public/downloads/Oscilobatiente-esloventanas-tilt-turn.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Tilt-Turn Window drawing</a></li></ul><p><br></p>",
        imageUrl: "https://eslowindows.com/img/5ea3307eedc83",
        finish_id: [
          /*{
            "id": 25,
            "name": "BraunDekor",
            "src": "https://eslowindows.com/img/5ea317ccedda3"
          },
          {
            "id": 26,
            "name": "Bronze",
            "src": "https://eslowindows.com/img/5ea317db1b4b2"
          },
          {
            "id": 27,
            "name": "Sheffield",
            "src": "https://eslowindows.com/img/5ea317eb8a392"
          },
          {
            "id": 28,
            "name": "TurnerOak",
            "src": "https://eslowindows.com/img/5ea317f891d8d"
          },
          {
            "id": 30,
            "name": "Mahagony",
            "src": "https://eslowindows.com/img/5ea3181210093"
          },
          {
            "id": 29,
            "name": "JetBlack",
            "src": "https://eslowindows.com/img/5ea3180636e3c"
          },
          {
            "id": 20,
            "name": "White",
            "src": "https://eslowindows.com/img/5ea31781edd53"
          },
          {
            "id": 21,
            "name": "Beige",
            "src": "https://eslowindows.com/img/5ea3178f68d40"
          },
          {
            "id": 22,
            "name": "Silver",
            "src": "https://eslowindows.com/img/5ea3179dd8f04"
          },
          {
            "id": 23,
            "name": "Nussbau",
            "src": "https://eslowindows.com/img/5ea317af77cfa"
          },
          {
            "id": 24,
            "name": "GoldenOak",
            "src": "https://esloventanas.com/img/5ea317bcb5322"
          }*/
        ],
        project_id: [
          /*{
            "id": 14,
            "name": "St George Utah Estados Unidos",
            "project_image": "https://eslowindows.com/img/5e877a46ca62c",
            "description": "<p>El Proyecto muy bonito en la zona montañosa con las rocas rojas de UTAH. Perfil de PVC acabado Jet Black y vidrios DUOS con LOW-E. Diseños especiales con esquinas al hueso para dar vista a las montañas.</p>"
          },
          {
            "id": 48,
            "name": "Casa Grande en Puerto San Jose del Cabo",
            "project_image": "https://eslowindows.com/img/5ea051db475d5",
            "description": "<p>Proyecto Casa Grande en Puerto San Jose del Cabo es una casa de lujo en la playa con ventanas y puertas de PVC acabado Golden Oak y vidrios laminados con barrotillo exterior de diferentes diseños - Puertas Corredizas Pockets, Ventanas con arco, Puertas en forma BAY, Ventanas con mallorquina y Mosquiteros Enrollables</p>"
          },
          {
            "id": 53,
            "name": "Casa en Pinar de la Venta en Zapopan",
            "project_image": "https://eslowindows.com/img/5ea063bf6d484",
            "description": "<p>Casa de lujo con ventaneria de PVC acabado Golden Oak en Pinar de la venta. Rodeado del Bosque de la primavera y la casa protegida con gran hermeticidad de las ventanas. Vista única e increíble al bosque a través de vidrios tamaños grandes. Ventanas BAY.</p>"
          },
          {
            "id": 16,
            "name": "Proyecto Baja DF",
            "project_image": "https://eslowindows.com/img/5e5011f80ea77",
            "description": "<p>Proyecto con diseños especiales de Puertas correderas grandes y cierres al hueso en esquina. Color de perfil de PVC - Bronze, Vidrios tamaños grandes DUO.</p>"
          },
          {
            "id": 22,
            "name": "Austin Texas Estados Unidos",
            "project_image": "https://eslowindows.com/img/5e9745233aac3",
            "description": "<p>Proyecto en Austin, Texas con ventanas de PVC acabado blanco. Vidrios especiales Low-E, con persianas enrollables Europeas. Diseños de ventanas con arco y ventanas circulares.</p>"
          },
          {
            "id": 63,
            "name": "Casa RP de RL Arquitectos en Guadalajara",
            "project_image": "https://eslowindows.com/img/5ea1ec905f78a",
            "description": "<p>Este increíble proyecto en estilo tradicional mexicano, también publicado en varias revistas como arquitectosmx.com o www.archdaily.com. El proyecto con ventanas de PVC acabado Nogal y Vidrios DUOS combina perfectamente con estilo de la casa.</p>"
          },
          {
            "id": 21,
            "name": "Casa en Aldama Irapuato",
            "project_image": "https://eslowindows.com/img/5e972e7c9f32f",
            "description": "<p>Proyecto en Irapuato, donde se utilizaron dos tipos de acabados en una casa - Beige y acabado de madera Nogal con persianas enrollables Europeas integradas.</p>"
          },
          {
            "id": 35,
            "name": "Casa Loft Pedregal en Queretaro",
            "project_image": "https://eslowindows.com/img/5e974a3d19e15",
            "description": "<p>Casa Loft con diseños especiales, acabado Bronze</p>"
          }*/
        ],
        galery: [
         /* "public/images/pages/products/product-13.webp",
          "public/images/pages/products/product-9.png",
          "public/images/pages/products/product-10.jpg",
          "public/images/pages/products/product-11.jpg",
          "public/images/pages/products/product-12.jpg",*/
        ],
        galeryVideo: [
          /*{
            "url": "ZS35myJKTbk",
            "imagen": "https://img.youtube.com/vi/ZS35myJKTbk/0.jpg"
          },
          {
            "url": "bznxNw1Gd-s",
            "imagen": "https://img.youtube.com/vi/bznxNw1Gd-s/0.jpg"
          }*/
        ],
        video: null,//"3BgwLE5p9Y8"
      },
    }
  },

  methods: {
    setIndex(index) {
      this.index = index
    },
    runCarousel(){
      length
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
    getProduct:function(id){
      axios.get(tools.url('/detalleproductFront/'+this.id)).then(
        ({data}) =>{
          this.producto=data;
          this.runCarousel();
          this.swiperOptionThumbs.loopedSlides = this.producto.galery.length;
        }
      );
    },
    openVideoModal(videoUrl) {
      this.modal.videoUrl = videoUrl;
      this.$refs['modal-video'].show();
    }
  },

  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    });

       this.id = this.$route.params.id;
     this.getProduct(this.id);
  }
}
</script>
